import { inject, Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  PromocodeResponse,
  UniquePromoCode,
} from '../models/promocode.response';
import { PromocodeData } from '../types/promocode-data.type';
import { PromocodeValidateData } from '../types/promocode-validate-data.type';

@Injectable({
  providedIn: 'root',
})
export class PromocodeApiService {
  private nydusNetworkApiService = inject(NydusNetworkApiDataService);

  validatePromocode(
    promocodeData: PromocodeValidateData,
  ): Observable<PromocodeData> {
    return this.nydusNetworkApiService
      .post<PromocodeResponse>('promo_codes/validate', promocodeData)
      .pipe(
        map((response) =>
          this.transformPromocodeResponse(promocodeData, response),
        ),
      );
  }

  showPromoCode(offerId: string): Observable<UniquePromoCode> {
    return this.nydusNetworkApiService.get<UniquePromoCode>(
      `offers/${offerId}/promo_codes`,
    );
  }

  assignPromoCode(offerId: string): Observable<UniquePromoCode> {
    return this.nydusNetworkApiService.post<UniquePromoCode>(
      'promo_codes/assign',
      { offer_id: offerId },
    );
  }

  private transformPromocodeResponse(
    validateData: PromocodeValidateData,
    response: PromocodeResponse,
  ): PromocodeData {
    const { cashPaid, pointsPaid } = response.data.attributes;

    const pointsAmount =
      'cash_redemption' in validateData
        ? validateData.cash_redemption.redemption_amount
        : validateData.points_transfer.transfer_amount;

    return {
      promocode: validateData.promo_code,
      promocodeUsage: {
        status: 'applied',
        remark: null,
        cashAmount: 0,
        // Since we don't use cash in RC and TC
        // so we will set the discount for cash to 0
        cashDiscount: 0,
        // We temporary calculate the points discount here
        // cause we don't use this field any where in the views for non-persistent promo code
        pointsDiscount: pointsAmount - pointsPaid,
        pointsAmount,
        pointsPaid,
        cashPaid,
      },
    };
  }
}
